
export const TOOLS_LIST = ["resizer", "rotator", "flipper", "cropper"];
export const TOOLS_DESCRIPTION = ["Resize Image", "Rotate Image", "Flip Image", "Crop Image"];